import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

const revealSelector = [
  // Headings have their own spring animation. Revealing their container again
  // causes an unwanted second vertical movement and typography reflow.
  'main p',
  'main .hero__actions', 'main .hero__assurances',
  'main .service-card', 'main .service-type',
  'main .work-card', 'main .web-design-work__card',
  'main .web-design-concepts__grid article',
  'main .web-design-benefits__grid article',
  'main .web-design-why__grid article',
  'main .web-design-included__card', 'main .web-design-handover',
  'main .web-design-types__grid article',
  'main .product-showcase', 'main .company-record__preview',
].join(', ')

export function ScrollReveal() {
  const location = useLocation()

  useLayoutEffect(() => {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    const root = document.querySelector('main')
    if (!root) return

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        entry.target.classList.add('scroll-reveal--visible')
        observer.unobserve(entry.target)
      }
    }, { rootMargin: '0px 0px -5% 0px', threshold: .08 })

    const register = () => {
      for (const element of root.querySelectorAll<HTMLElement>(revealSelector)) {
        // Keep the Services navigator immediately stable when switching groups;
        // its headings and cards must not animate or resize on state changes.
        if (element.closest('#services')) continue
        if (element.classList.contains('scroll-reveal') || element.parentElement?.closest('.scroll-reveal')) continue
        element.classList.add('scroll-reveal')
        observer.observe(element)
      }
    }

    register()
    const changes = new MutationObserver(register)
    changes.observe(root, { childList: true, subtree: true })

    return () => {
      changes.disconnect()
      observer.disconnect()
      for (const element of root.querySelectorAll('.scroll-reveal')) {
        element.classList.remove('scroll-reveal', 'scroll-reveal--visible')
      }
    }
  }, [location.pathname])

  return null
}
